<template>
    <div id="loginOverlay" class="overlay">
      <div id="loginModal" class="modal" v-click-outside="toggleLoginModal">
        <div class="modal-header">
          <div id="loginHeader">LOGIN</div>
        </div>
        <div id="loginContent" class="modal-content">
          <div id="loginErrorMessage" v-if="showLoginErrorMessage" v-html="loginErrorMessage"></div>
          <div id="loginForm">
<!--             <div class="login-item">
              <div class="item-label">User Type</div>
              <SearchDropdown v-model="selectedUserType" dropType="simple" :items="userTypes" title="Select User" @update:modelValue="clearErrorAndUser" />
            </div> -->
            <div class="login-item">
              <div class="item-label">{{(rounds[currentRound].roundType === 'Individual' ? 'User' : 'Team')}}</div>
              <SearchDropdown v-model="userCredentials.id" :items="simpleUsers" :title="(rounds[currentRound].roundType === 'Individual' ? 'Select User' : 'Select Team')" @update:modelValue="clearError" />
            </div>
<!--             <div class="login-item">
              <div class="item-label">Password</div>
              <input id="userPassword" type="password" v-model="userCredentials.password" placeholder="Password" @input="clearError" @keydown.enter="attemptLogin" />
            </div> -->
          </div>
          <div id="loginControls">
            <div id="loginButton" class="game-button" :class="{'disabled': loginDisabled}" @click="login(userCredentials)">LOG IN</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import SearchDropdown from './SearchDropdown.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LoginModal',
  components: {
    SearchDropdown
  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'users',
      'showLoginErrorMessage',
      'loginErrorMessage',
      'rounds',
      'currentRound'
    ]),
    simpleUsers(){
      const theLoginModal = this;
      return theLoginModal.users.filter(user => user.userType === theLoginModal.rounds[theLoginModal.currentRound].roundType).map(user => {
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          id: user.id,
          userType: user.userType
        }
      })
    },
    loginDisabled(){
      const theLoginModal = this;
      return (theLoginModal.userCredentials.id === '' || theLoginModal.userCredentials.password === '' || theLoginModal.showLoginErrorMessage)
    },
  },
  methods: {
    ...mapActions([
      'login',
      'toggleLoginModal',
      'toggleLoginError'
    ]),
    clearError(){
      const theLoginModal = this;
      if(theLoginModal.showLoginErrorMessage){
        theLoginModal.toggleLoginError({message: '', visible: false})
      }
    },
    clearErrorAndUser(){
      const theLoginModal = this;
      if(theLoginModal.showLoginErrorMessage){
        theLoginModal.toggleLoginError({message: '', visible: false})
      }
      theLoginModal.userCredentials.id = '';
    },
    attemptLogin(){
      const theLoginModal = this;
      if(!theLoginModal.loginDisabled){
        theLoginModal.login(theLoginModal.userCredentials)
      }
    }
  },
  mounted(){

  },
  beforeUnmount(){

  },
  data: function(){
    return {
      userCredentials: {
        id: '',
        password: 'pass123'
      },
      userTypes: ['Individual', 'Team'],
      selectedUserType: '',
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style>
  #loginOverlay{

  }

  #loginModal{

  }

  #loginHeader{
    
  }

  #loginContent{

  }

  #loginContent.modal-content{
    overflow-y: initial; /* NOTE: THIS IS SET TO auto EVERYWHERE ELSE TO ALLOW FOR SCROLLING; THIS IS DIFFERENT HERE TO ALLOW OVERFLOW OF DROPDOWN AND SCROLL OF ALL USERS  */
  }

  #loginForm{
    width: 80%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }

  #loginErrorMessage{
    font-size: 20px;
    font-weight: bold;
    padding: 10px 0px;
    width: 80%;
    margin: 20px auto 10px auto;
  }

  .login-item{
    margin-top: 15px;
  }

  .login-item select, .login-item input{
    width: 100%;
    padding: 5px;
    margin: 5px auto;
  }

  .login-item input::placeholder{
    font-weight: bold;
  }

  .item-label{
    text-align: left;
    font-weight: bold;
    font-size: 20px;
  }

  #loginControls{
    width: 100%;
    max-width: 200px;
    margin-top: 20px;
    margin: 10px auto;
  }

  #loginButton{
    font-size: 24px;
    transition: all 0.25s;
  }
  #loginButton:hover{
    cursor: pointer;
  }

  #loginButton.disabled{
    pointer-events: none;
    background-color: rgba(51, 51, 51, 0.4);
    color: rgba(255, 255, 255, 0.4);
  }
</style>